import { msg } from 'api';
import FilterType from 'apps/catalogue/models/FilterType';
import { getMetaTitle, prepareFiltersAsParams } from 'apps/meta/utils';

const getDietaryFilters = (filter) =>
  filter.filterType === FilterType.DIETARY || filter.filterType === FilterType.CUSTOM_DIETARY;
const getOptionFilters = (filter) =>
  filter.filterType === FilterType.OPTION || filter.filterType === FilterType.CUSTOM_OPTION;
const getBrandFilters = (filter) =>
  filter.filterType === FilterType.BRAND || filter.filterType === FilterType.CUSTOM_BRANDS;
const getOtherFilters = (filter) =>
  filter.filterType === FilterType.CUSTOM;

const filterNameCompare = (a, b) => a.name.localeCompare(b.name);
const uniqueFilterName = (elem, pos, arr) => (pos === 0 ? true : elem.name !== arr[pos - 1].name);
const getFilterName = filter => filter.name;

export const getCategoryName = (category) =>
  (category && category.length > 0 ? category[category.length - 1].name : null);

export const getAllFilters = (pageParameters) => {
  const { filters = [], customFilters = [] } = pageParameters;
  return [...filters, ...customFilters].sort(filterNameCompare).filter(uniqueFilterName);
};

export const noFilters = (pageParameters) => !pageParameters.filters && !pageParameters.customFilters;
export const getDietaryFiltersNames = (allFilters) => allFilters.filter(getDietaryFilters).map(getFilterName);
export const getOptionFiltersNames = (allFilters) => allFilters.filter(getOptionFilters).map(getFilterName);
export const getBrandFiltersNames = (allFilters) => allFilters.filter(getBrandFilters).map(getFilterName);
export const getOtherFiltersNames = (allFilters) => allFilters.filter(getOtherFilters).map(getFilterName);
export const splitFilters = (pageParameters) => {
  const allFilters = getAllFilters(pageParameters);
  return {
    brandFilters: getBrandFiltersNames(allFilters),
    dietaryFilters: getDietaryFiltersNames(allFilters),
    optionFilters: getOptionFiltersNames(allFilters),
    otherFilters: getOtherFiltersNames(allFilters),
  };
};

const getOptionalSuffix = (basePath) => {
  if (basePath === '/regulars') {
    return ' with Regulars';
  }

  if (basePath === '/on-offer') {
    return ' Offers';
  }

  return '';
};

export const getRootPageTitle = (basePath, pageMetaData) => {
  if (basePath === '/browse') {
    const title = getMetaTitle(pageMetaData, {
      titleSuffix: msg.page.titleSuffix,
      siteTitle: msg.page.title,
    });
    return title || `Your weekly shop, perfectly delivered with the online supermarket${msg.page.titleSuffix}`;
  }

  if (basePath === '/on-offer') {
    return `Offers${msg.page.offersTitleSuffix}`;
  }

  if (basePath === '/regulars') {
    return `Regulars${msg.page.titleSuffix}`;
  }

  return msg.page.longTitle;
};

export const getSearchPageTitle = (pageMetaData, promotedSearchTitle, searchTerm) => {
  const title = getMetaTitle(pageMetaData, { searchTerm, siteTitle: msg.page.title });

  if (title) {
    return title;
  }

  if (promotedSearchTitle) {
    return `${promotedSearchTitle} from ${msg.page.title}`;
  }

  return `${searchTerm} from ${msg.page.title}`;
};

export const getCategoryPageTitle = (basePath, pageMetaData, pageParameters) => {
  const { category } = pageParameters;
  const categoryName = getCategoryName(category);

  const categorisedFilters = splitFilters(pageParameters);
  const optionalSuffix = getOptionalSuffix(basePath);

  const title = getMetaTitle(pageMetaData, {
    category: categoryName,
    optionalSuffix,
    siteTitle: msg.page.title,
    titleSuffix: msg.page.titleSuffix,
    ...prepareFiltersAsParams(categorisedFilters),
  });

  return title || `${[
    ...categorisedFilters.brandFilters,
    ...categorisedFilters.dietaryFilters,
    categoryName,
    ...categorisedFilters.otherFilters,
    ...categorisedFilters.optionFilters,
  ].join(' ')}${optionalSuffix} ${msg.page.titleSuffix}`.replace(/ +/g, ' ');
};
